import { combineReducers } from "@reduxjs/toolkit";

import customerFormReducer from "../pages/customer-form/customer-form.slice";
import voucherFormReducer from "../pages/voucher-form/voucher-form.slice";
import voucherLinkReducer from "../pages/new-channel-partner-form/new-cp-form.slice";
import newBookingFormReducer from "../pages/new-booking-form/new-booking-form.slice";
import countryReducer from "../shared-components/phone-input/phone-input-slice"

const rootReducer = combineReducers({
  customerForm: customerFormReducer,
  voucherForm: voucherFormReducer,
  voucherLink: voucherLinkReducer,
  newBookingForm: newBookingFormReducer,
  countries: countryReducer,
});

export default rootReducer;
